import {Component, OnInit, OnDestroy} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {PagesService} from '../../shared/services/pages.service';
import {SEOService} from '../../shared/services/seo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CmsService } from '../../cms/services/cms.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-about-us-page',
  templateUrl: './about-us-page.component.html',
  styleUrls: ['./about-us-page.component.scss']
})
export class AboutUsPageComponent implements OnInit, OnDestroy {
  private destroy$: Subject<any> = new Subject();

  public isLoaded: boolean = false;

  public legacyAboutUs = null;

  public aboutUsPage = null;
  public aboutUsPageURL = "chi-siamo"; // TEMP

  constructor(private _pagesService: PagesService,
              private _router: Router,
              private _cmsService: CmsService,
              private _seoService: SEOService) { }

  ngOnInit(): void {
    this._seoService.setTitle('Chi Siamo');


    this._cmsService.hasCmsEnabled$.pipe(takeUntil(this.destroy$)).subscribe(isEnabled => {
      if (isEnabled != undefined && isEnabled == true) {
        this.getAboutUsPage(3);
      } else if (isEnabled != undefined && isEnabled == false) {
        //Legacy
        this._pagesService.getAboutUs().pipe(takeUntil(this.destroy$)).subscribe(x => {
          if (x) {
            this.legacyAboutUs = x;
            this.isLoaded = true;
          }
        });
      }
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  private getAboutUsPage(retry) {
    if (retry == 0) {
      this._router.navigate([""]);
    } else {
      const allPages = this._cmsService.getPages();
      if (allPages) {
        let page = allPages.find(x => x.path == this.aboutUsPageURL);
        this._cmsService.getPageById(page.id).pipe(takeUntil(this.destroy$)).subscribe(page => {
          this.aboutUsPage = page;
          this.isLoaded = true;
        })
      } else {
        setTimeout(() => {
          retry--;
          this.getAboutUsPage(retry);
        }, 250)
      }
    }
  }

}
